/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=new FinalizationRegistry(n=>{n.close()});function e(e,i){n.register(e,i,i)}function i(e){n.unregister(e)}export{e as register,i as unregister};
